import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("Todos");
  const cats = ["Todos", "Estilismo", "Barbería", "Uñas", "Pestañas"];

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  const filtered = filter === "Todos" ? items : items.filter((i) => i.category === filter);

  return (
    <section id="galeria" className="section bg-[#fafafa]" data-testid="gallery-section">
      <div className="container-ie">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-12">
          <div className="md:col-span-8">
            <div className="flex items-center gap-3 mb-5">
              <span className="dot-red" />
              <span className="overline">Resultados Reales</span>
            </div>
            <h2 className="font-display font-semibold tracking-tighter text-4xl md:text-5xl lg:text-6xl text-[#0a0a0a]">
              Trabajos de nuestras
              <br /> <span className="italic font-light">alumnas y alumnos.</span>
            </h2>
          </div>
          <div className="md:col-span-4 flex flex-wrap gap-2">
            {cats.map((c) => (
              <button
                key={c}
                data-testid={`gallery-filter-${c.toLowerCase()}`}
                onClick={() => setFilter(c)}
                className={`text-xs uppercase tracking-[0.18em] font-semibold px-4 py-2 border transition-colors ${
                  filter === c
                    ? "bg-[#0a0a0a] text-white border-[#0a0a0a]"
                    : "bg-transparent text-[#0a0a0a] border-black/15 hover:border-[#0a0a0a]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="masonry" data-testid="gallery-grid">
          {filtered.map((g, i) => (
            <motion.div
              key={`${g.url}-${i}`}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: (i % 6) * 0.06 }}
              className="relative group"
            >
              <div className="overflow-hidden bg-neutral-100">
                <img
                  src={g.url}
                  alt={g.category}
                  className="w-full h-auto block"
                  loading="eager"
                  decoding="async"
                />
              </div>
              <div className="absolute left-3 top-3 bg-white/85 backdrop-blur-md px-3 py-1 text-[0.65rem] uppercase tracking-[0.18em] font-semibold text-[#0a0a0a]">
                {g.category}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
